var map = {
	"./boxplot": "99fd",
	"./boxplot.json": "99fd",
	"./cornstover_flowsheet.png": "69fa",
	"./oilcane_flowsheet.png": "adf9",
	"./refineries": "6f92",
	"./refineries.json": "6f92",
	"./singleParameters": "5869",
	"./singleParameters.json": "5869",
	"./singleTable": "393d",
	"./singleTable.json": "393d",
	"./spearman": "8cb6",
	"./spearman.json": "8cb6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0743";